module.exports = __webpack_public_path__ + "static/ClickedDamagedLostItem-495c041ee4109c7ed5fa712c394d56e3.png";